import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { IFaqItems } from 'types/interfaces';

export const FaqApi = {
    getFaqs: (id?: string): Promise<AxiosResponse<IFaqItems[]>> =>
        axiosInstance.get<IFaqItems[]>(`faq${id ? '/' + id : ''}`),
};
